import React, {useCallback, useEffect, useState} from 'react'
import Table from "../Components/Table/Table";
import {Link} from "react-router-dom";
import {Api} from "../../../helpers/Api";
import Heading from "../Components/Heading/Heading";
import columnConfig from "../Main/Dashboard/columns";
import {connect} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import { Container } from 'react-bootstrap';
import LoadingSpinner from '../Components/Spinner/LoadingSpinner';

const imageContainer = {
    display: 'flex',
    justifyContent: 'left',
    flexWrap: 'wrap',
    gap: '10px',
}

const headStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
}

const yearSelect = {
    width: '90px'
}

const imgContainer = { 
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    width: '150px'
};

const img = {
    width: '150px', /* Adjust size */
    height: '150px',
    objectFit: 'cover', /* Ensures images fit well */
    borderRadius: '8px' /* Optional: Rounded corners */
}

const MediaDepartmentList = ({user, ...props}) => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(()=>{
        Api.call(`/departmentNameWithId`).then((res) => {
            setData(res);
        }).catch((err) => { 
            console.log(err);
        }).finally(() => {
            setLoading(false);
        });
    },[])

    return ( loading ? <LoadingSpinner /> :
        <div className="right_container">
            <div className="dashboard">
                <div className='inner-content'>
                    <div style={imageContainer}>
                        {
                            data.map((item, index) => {
                                return <div key={`container${index}`} style={imgContainer} onClick={() => {navigate(`/mediaCollection/${item?.Id}`)}}>
                                <img style={img} src='../../../../images/Files-Icon-PNG-HD-Quality.png' alt="image" /> 
                                <p>{item?.name}</p>
                            </div>
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
    }

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatchLogin: (user) => dispatch({type: 'LOGIN', data: user})
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MediaDepartmentList);
